module.exports = __webpack_public_path__ + "static/image_1-457fc6bc03b4b06ecb496755ed67ce3d.jpg";